import { fabric } from "fabric";
import { cloneDeep } from "lodash";
import reduxStore from "../../configureEnvStore";
import { DEVICE_TYPES, KEYBOARD_KEYS, NAMED_SHAPE_TYPE, SHAPE_TYPE, shapeStatus } from "../../constants/Constants";
import { MOUSE_EVENTS, MaximumCharForText, MaximumCharInOneLine, shapeTextObj, uploadMarkupRootScope } from "../../constants/MarkupConstants";
import { UPLOAD_FILES_DATA } from "../../constants/UploadFilesConstants";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import { setSelectedShapeType } from "../../reducers/markup-reducer";
import { LogFirebase } from "../firestore";
import googleEvent from "../googleEvent";
import Localize from "../../locale/Localize";
import { updateImagesArray } from "../../reducers/uploadFile-reducer";
import BlurShapeService from "./BlurShapeService";
import RectangleShapeService from "./RectangleShapeService";
import ArrowShapeService from "./ArrowShapeService";
import TextService from "./TextService";
import {
    addInShapeList,
    checkIsTextBoxEmpty,
    disableClearMarkup,
    disableMarkupRedo,
    disableMarkupUndo,
    drawOnCanvas,
    enableClearMarkup,
    enableMarkupRedo,
    enableMarkupUndo,
    resetMarkupUndoList,
    setFreeDrawBrush,
} from "../../components/Markup/MarkupFunction";
import { EVENT_NAME } from "../../constants/GTagConstants";

class UploadFileMarkupService {
    currentShapeCount = 0;
    firstTime = true;
    isDragging = false;
    isDrawingRect = false;
    isMovingRect = false;
    isDrawingBlur = false;
    isMovingBlur = false;
    isDrawingArrow = false;
    isMovingArrow = false;
    isMovingText = false;
    markupVar = {
        shape: null,
        undoEnabled: false,
        redoEnabled: false,
        MarkupDefaultText: null,
        clearMarkup: false,
    };
    arrowObj = null;
    rect = null;
    textbox = null;
    origX = null;
    origY = null;
    pointer = null;
    newLineAdded = false;
    currTimeStamp = null;

    toggleShapeSelection = (shapeType) => {
        const currShape = reduxStore.getState().markup.selectedShapeType;
        if (currShape === shapeType) {
            this.deselectShape(shapeType);
        } else {
            this.selectShape(shapeType);
        }
    };

    selectShape = (shapeType) => {
        this.checkMarkupTextStatus();
        reduxStore.dispatch(setSelectedShapeType(shapeType));
        this.markupVar.shape = shapeType;
        if (shapeType === SHAPE_TYPE.FREEDRAW) {
            setFreeDrawBrush();
            googleEvent.logEvent(EVENT_NAME.MARKUP_FREEDRAW);
            LogFirebase("Upload files", "markup", { name: UPLOAD_FILES_DATA.selectedImageObj.name, event: "select_freedraw" });
        } else if (shapeType === SHAPE_TYPE.RECT) {
            googleEvent.logEvent(EVENT_NAME.MARKUP_RECT);
            LogFirebase("Upload files", "markup", { name: UPLOAD_FILES_DATA.selectedImageObj.name, event: "select_rectangle" });
        } else if (shapeType === SHAPE_TYPE.TEXT) {
            const localisedValues = Localize[PublicVariables.currentLanguageObj.languageCode];
            this.markupVar.MarkupDefaultText = localisedValues["enter_text_here"];
            googleEvent.logEvent(EVENT_NAME.MARKUP_TEXT);
            LogFirebase("Upload files", "markup", { name: UPLOAD_FILES_DATA.selectedImageObj.name, event: "select_text" });
        } else if (shapeType === SHAPE_TYPE.BLUR) {
            googleEvent.logEvent(EVENT_NAME.MARKUP_MASK);
            LogFirebase("Upload files", "markup", { name: UPLOAD_FILES_DATA.selectedImageObj.name, event: "select_mask_rectangle" });
        } else if (shapeType === SHAPE_TYPE.ARROW) {
            googleEvent.logEvent(EVENT_NAME.MARKUP_ARROW);
            LogFirebase("Upload files", "markup", { name: UPLOAD_FILES_DATA.selectedImageObj.name, event: "select_arrow" });
        }

        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        if (shapeType !== SHAPE_TYPE.FREEDRAW) {
            annCanvas.isDrawingMode = false;
        }

        this.setSelecteCurrentShape();
        if (this.firstTime) {
            this.firstTime = false;
            this.startAnnotation();
        }
    };

    setSelecteCurrentShape = () => {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        if (annCanvas) {
            /* Here optional character not working with annCanvas, so added if condition */
            annCanvas.forEachObject((obj) => {
                //make local shapes selectable when user is in that shape mode
                if (obj.shape_type === this.markupVar.shape && obj.localShape !== undefined && obj.localShape === true) {
                    obj.set("selectable", true);
                    obj.set("evented", true);
                    if (obj.shape_type === SHAPE_TYPE.FREEDRAW) {
                        obj.set("hoverCursor", "default"); //free text is not moveable
                    } else {
                        obj.set("hoverCursor", "grabbing");
                    }
                    console.log("selectable");
                    console.log(obj);
                } else {
                    obj.set("selectable", false);
                    obj.set("evented", false);
                    obj.set("hoverCursor", "default");
                    console.log("UNselectable");
                    console.log(obj);
                }
            });
        }
    };

    deselectShape = (shapeType) => {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        if (shapeType === SHAPE_TYPE.FREEDRAW) {
            LogFirebase("Upload files", "markup", { name: UPLOAD_FILES_DATA.selectedImageObj.name, event: "deselect_freedraw" });
            annCanvas.isDrawingMode = false;
        } else if (shapeType === SHAPE_TYPE.RECT) {
            LogFirebase("Upload files", "markup", { name: UPLOAD_FILES_DATA.selectedImageObj.name, event: "deselect_rectangle" });
            this.isDrawingRect = false;
            this.isMovingRect = false;
        } else if (shapeType === SHAPE_TYPE.TEXT) {
            LogFirebase("Upload files", "markup", { name: UPLOAD_FILES_DATA.selectedImageObj.name, event: "deselect_text" });
            this.isMovingText = false;
        } else if (shapeType === SHAPE_TYPE.BLUR) {
            LogFirebase("Upload files", "markup", { name: UPLOAD_FILES_DATA.selectedImageObj.name, event: "deselect_mask_rectangle" });
            this.isDrawingBlur = false;
            this.isMovingBlur = false;
        } else if (shapeType === SHAPE_TYPE.ARROW) {
            LogFirebase("Upload files", "markup", { name: UPLOAD_FILES_DATA.selectedImageObj.name, event: "deselect_arrow" });
            this.isDrawingArrow = false;
            this.isMovingArrow = false;
        }

        this.markupVar.shape = null;
        reduxStore.dispatch(setSelectedShapeType(null));
        this.deselectAllObj(); // user should not be able to select/move any obj
    };

    deselectAllObj = function () {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        annCanvas?.forEachObject(function (obj) {
            //make local shapes selectable when user is in that shape mode
            if (obj.localShape !== undefined) {
                obj.set("selectable", false);
                obj.set("evented", false);
                obj.set("hoverCursor", "default");
            }
        });
    };

    checkMarkupTextStatus = () => {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        // If canvas is there then only go to check text
        if (this.markupVar.shape != null && this.markupVar.shape == SHAPE_TYPE.TEXT && annCanvas) {
            const txt = annCanvas.getActiveObject();
            if (txt != null && txt.shape_type == SHAPE_TYPE.TEXT) {
                const retFlag = checkIsTextBoxEmpty(txt);
                if (!retFlag) {
                    txt.exitEditing();
                }
            }
        }
    };

    startAnnotation = () => {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        annCanvas
            .on("mouse:up", (o) => {
                if (this.markupVar.shape === SHAPE_TYPE.FREEDRAW) {
                    this.isDragging = false;
                    this.freeDrawing(MOUSE_EVENTS.UP, o);
                }
                if (this.markupVar.shape === SHAPE_TYPE.RECT) {
                    RectangleShapeService.rectangleDrawing(MOUSE_EVENTS.UP, o);
                }
                if (this.markupVar.shape === SHAPE_TYPE.BLUR) {
                    BlurShapeService.blurDrawing(MOUSE_EVENTS.UP, o);
                }
                if (this.markupVar.shape === SHAPE_TYPE.ARROW) {
                    ArrowShapeService.arrowDrawing(MOUSE_EVENTS.UP, o);
                }
                if (this.markupVar.shape === SHAPE_TYPE.TEXT) {
                    TextService.textAddInCanvas(MOUSE_EVENTS.UP, o);
                }
                if (this.markupVar.shape !== null && this.markupVar.shape !== SHAPE_TYPE.TEXT) {
                    // show on footer image
                    this.reflectMarkupOnFooter();
                }
            })
            .on("mouse:down", (o) => {
                if (this.markupVar.shape === SHAPE_TYPE.FREEDRAW) {
                    this.isDragging = true;
                }
                if (this.markupVar.shape === SHAPE_TYPE.RECT) {
                    RectangleShapeService.rectangleDrawing(MOUSE_EVENTS.DOWN, o);
                }
                if (this.markupVar.shape === SHAPE_TYPE.BLUR) {
                    BlurShapeService.blurDrawing(MOUSE_EVENTS.DOWN, o);
                }
                if (this.markupVar.shape === SHAPE_TYPE.ARROW) {
                    ArrowShapeService.arrowDrawing(MOUSE_EVENTS.DOWN, o);
                }
                if (this.markupVar.shape === SHAPE_TYPE.TEXT) {
                    TextService.textAddInCanvas(MOUSE_EVENTS.DOWN, o);
                }
            })
            .on("mouse:move", (o) => {
                if (this.markupVar.shape === SHAPE_TYPE.RECT) {
                    RectangleShapeService.rectangleDrawing(MOUSE_EVENTS.MOVE, o);
                }
                if (this.markupVar.shape === SHAPE_TYPE.BLUR) {
                    BlurShapeService.blurDrawing(MOUSE_EVENTS.MOVE, o);
                }
                if (this.markupVar.shape === SHAPE_TYPE.ARROW) {
                    ArrowShapeService.arrowDrawing(MOUSE_EVENTS.MOVE, o);
                }
            })
            .on("path:created", ({ path }) => {
                if (this.markupVar.shape == SHAPE_TYPE.FREEDRAW) {
                    if (this.isDragging) {
                        const dateTime = new Date();
                        this.currTimeStamp = dateTime.getTime();
                        path.id = this.currTimeStamp; //need to assign id and localShape prop for undo redo
                        path.localShape = true;
                        path.shape_type = SHAPE_TYPE.FREEDRAW;
                    }
                }
            })
            .on("object:moving", (o) => {
                if (this.markupVar.shape === SHAPE_TYPE.RECT) {
                    this.isDrawingRect = false;
                    this.isMovingRect = true;
                }
                if (this.markupVar.shape === SHAPE_TYPE.BLUR) {
                    this.isDrawingBlur = false;
                    this.isMovingBlur = true;
                }
                if (this.markupVar.shape === SHAPE_TYPE.ARROW) {
                    this.isDrawingArrow = false;
                    this.isMovingArrow = true;
                }
                if (this.markupVar.shape === SHAPE_TYPE.TEXT) {
                    const txt = o.target;
                    if (txt !== null && txt.shape_type !== SHAPE_TYPE.TEXT) {
                        return;
                    }
                    this.isMovingText = true;
                }
            })
            .on("text:editing:entered", (o) => {
                if (this.markupVar.shape === SHAPE_TYPE.TEXT) {
                    console.log(o);
                }
            })
            .on("text:editing:exited", () => {
                if (this.markupVar.shape === SHAPE_TYPE.TEXT) {
                    console.log("text edit exited");
                    let txt = annCanvas.getActiveObject();
                    //once placed, textbox should not be editable
                    txt.set({ editable: false });
                    console.log(txt);
                    addInShapeList(txt);
                    this.handleShapeCount(1);
                    if (uploadMarkupRootScope.isResetted || uploadMarkupRootScope.escape || checkIsTextBoxEmpty(txt)) {
                        return false;
                    }
                    annCanvas.discardActiveObject();
                    annCanvas.renderAll();
                    this.reflectMarkupOnFooter();
                    this.addShapeCountLog(shapeStatus.DRAW);
                }
            });
        fabric.Object.prototype.objectCaching = false;

        /** To bind the enter key with every textbox  */
        fabric.IText.prototype.onKeyDown = (() => {
            const _this = this;
            return function (e) {
                if (_this.markupVar.shape !== SHAPE_TYPE.TEXT) {
                    return;
                }
                if (this.text.length > MaximumCharInOneLine) {
                    let newLine = "\n";
                    let txt = this.text;
                    let posNewLine = txt.search(newLine);
                    if (posNewLine < 0 && txt != _this.markupVar.MarkupDefaultText) {
                        let formattedText = _this.formatNewLineText(this);
                        _this.changeText(formattedText, this);
                    } else {
                        console.log("NO new line");
                    }
                }
                if (GLOBAL_MEETING_DATA.device_type == DEVICE_TYPES.DESKTOP) {
                    //desktop keydown behaves different so block keys
                    if (this.text.length > MaximumCharForText - 1) {
                        if (
                            e.keyCode == KEYBOARD_KEYS.BACKSPACE ||
                            e.keyCode == KEYBOARD_KEYS.DELETE ||
                            e.keyCode == KEYBOARD_KEYS.ENTER ||
                            e.keyCode == KEYBOARD_KEYS.RIGHT_ARROW ||
                            e.keyCode == KEYBOARD_KEYS.LEFT_ARROW
                        ) {
                            console.log("allow action");
                            //allow keydown of backspace,delete,enter and left-right arrow
                        } else {
                            e.preventDefault();
                            return false;
                        }
                    }
                }

                if (e.keyCode == KEYBOARD_KEYS.ENTER) {
                    console.log("enter key pressed");
                    e.preventDefault();
                    this.exitEditing();
                    return false;
                }
            };
        })(fabric.IText.prototype.onKeyDown);

        fabric.IText.prototype.onKeyUp = (() => {
            const _this = this;
            return function (e) {
                if (GLOBAL_MEETING_DATA.device_type != DEVICE_TYPES.DESKTOP) {
                    //mweb behaves differently than web so handle on keyup
                    if (this.text.length > MaximumCharForText) {
                        const newText = this.text.substr(0, MaximumCharForText);
                        _this.changeText(newText, this);
                    }
                }
                if (_this.markupVar.shape !== SHAPE_TYPE.TEXT) {
                    return;
                }
                console.log("onKeyUp");
                //FIX : backspace and enter in android chrome appends "\nEnter"
                console.log("code=" + e.keyCode + "::text=" + this.text);
                let fromLast = "";
                let backspace = false;
                let enterkey = false;
                if (this.text.indexOf("\nEnter", fromLast) > -1) {
                    enterkey = true;
                    fromLast = this.text.length - "\nEnter".length + 1;
                }
                if (this.text.indexOf(" Enter", fromLast) > -1) {
                    backspace = true;
                    fromLast = this.text.length - " Enter".length + 1;
                }
                console.log("::backspace=" + backspace + "::enterkey=" + enterkey);
                if (backspace || enterkey) {
                    let tempText = this.text.substr(0, fromLast - 1);
                    console.log("after removing enter");
                    if (enterkey) {
                        this.textLines.pop();
                    }
                    this.text = tempText;
                    console.log(this);
                }
            };
        })(fabric.IText.prototype.onKeyUp);
    };

    changeText = function (newText, txtObj) {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        txtObj.selectAll();
        txtObj.text = newText;
        txtObj.hiddenTextarea.value = newText;
        txtObj.dirty = true;
        txtObj.setCoords();
        annCanvas.renderAll();
    };

    formatNewLineText = (txtObj) => {
        let formattedText = "";
        if (txtObj.text.length > 18) {
            formattedText = txtObj.text.substr(0, 18) + "\n" + txtObj.text.substr(18, txtObj.text.length);
        } else {
            formattedText = txtObj.text;
        }
        return formattedText;
    };

    freeDrawing = (type) => {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        if (type === MOUSE_EVENTS.UP) {
            annCanvas?.forEachObject((o) => {
                o.selectable = false;
            });
            this.handleShapeCount(1);
            annCanvas.renderAll();
            this.prepareShapesList(); // prepare Local Shapes List over here
            //when new object is drawn, redo can not be done on earlier undone objects.so clear it.
            resetMarkupUndoList();
            this.addShapeCountLog(SHAPE_TYPE.DRAW);
        }
    };

    changeMarkupShapeList = (movedObj) => {
        if (this.localObjExistOnMarkupCanvas()) {
            this.prepareShapesList();
        }
        let updated = false;
        UPLOAD_FILES_DATA.selectedImageObj.shapeList.forEach((localObj, key) => {
            if (localObj.id == movedObj.id && !updated) {
                UPLOAD_FILES_DATA.selectedImageObj.shapeList.splice(key, 1); //remove from old index
                UPLOAD_FILES_DATA.selectedImageObj.shapeList.push(movedObj); //make it latest
                updated = true;
            }
        });
    };

    reflectMarkupOnFooter = () => {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        const imageData = annCanvas.toDataURL("image/jpeg");
        let updatedImageArray = cloneDeep(reduxStore.getState().uploadFile.imagesArray);
        const reflectObjIndex = this.getSelectedFileIndex();
        if (reflectObjIndex > -1) {
            updatedImageArray[reflectObjIndex].updatedSrc = imageData;
            this.updateThumbnail(updatedImageArray[reflectObjIndex].updatedSrc, function (thumbnailData) {
                updatedImageArray[reflectObjIndex].thumbnail = thumbnailData;
                updatedImageArray[reflectObjIndex].updatedSrc = thumbnailData;
                UPLOAD_FILES_DATA.selectedImageObj = {
                    ...UPLOAD_FILES_DATA.selectedImageObj,
                    thumbnail: thumbnailData,
                    updatedSrc: thumbnailData,
                };
                reduxStore.dispatch(updateImagesArray(updatedImageArray));
            });
        }
    };

    updateThumbnail = function (imageData, callback) {
        let img = new Image();
        img.onload = function () {
            const dimention = this.width + "*" + this.height;
            let ratio = this.width / this.height;
            if (ratio > 1) {
                this.width = 80;
                this.height = this.width / ratio;
            } else {
                this.height = 80;
                this.width = this.height * ratio;
            }

            callback(this.src, dimention);
        };
        img.src = imageData;
    };

    prepareShapesList() {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        let allLocals = annCanvas.getObjects().filter((obj) => (obj.localShape && obj.localShape === true) || (obj.localshape && obj.localshape));
        if (UPLOAD_FILES_DATA.selectedImageObj) {
            UPLOAD_FILES_DATA.selectedImageObj.shapeList = [...allLocals];
        }
        if (UPLOAD_FILES_DATA.selectedImageObj.shapeList.length > 0) {
            enableMarkupUndo();
            enableClearMarkup();
        }
    }

    addRemoveOBJOnCanvas = (obj, isUndo = false) => {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        return new Promise((resolve, _reject) => {
            if (isUndo) {
                annCanvas.remove(obj);
            } else {
                annCanvas.add(obj);
            }

            setTimeout(() => {
                resolve(true);
            }, 100);
        });
    };

    localObjExistOnMarkupCanvas = () => {
        return UPLOAD_FILES_DATA.selectedImageObj.shapeList.length !== 0;
    };

    undoMarkupLocalObject = () => {
        if (UPLOAD_FILES_DATA.selectedImageObj?.shapeList.length == 0) {
            this.prepareShapesList();
        }
        if (UPLOAD_FILES_DATA.selectedImageObj?.shapeList.length > 0) {
            this.handleShapeCount(-1);
            this.addShapeCountLog(shapeStatus.UNDO);
            let latestObj = UPLOAD_FILES_DATA.selectedImageObj.shapeList[UPLOAD_FILES_DATA.selectedImageObj.shapeList.length - 1];
            UPLOAD_FILES_DATA.selectedImageObj.shapeList.pop();
            this.addRemoveOBJOnCanvas(latestObj, true).then(() => {
                UPLOAD_FILES_DATA.selectedImageObj.undoList.push(latestObj);
                //after undo if any obj exist on canvas then only undo should be enabled
                if (!this.localObjExistOnMarkupCanvas()) {
                    disableMarkupUndo();
                    disableClearMarkup();
                } else {
                    enableMarkupUndo();
                    enableClearMarkup();
                }
                enableMarkupRedo();
                this.reflectMarkupOnFooter();
            });
        }
        googleEvent.logEvent(EVENT_NAME.UNDO_TAPPED);
    };

    redoMarkupLocalObject = () => {
        if (UPLOAD_FILES_DATA.selectedImageObj?.undoList.length > 0) {
            this.handleShapeCount(1);
            this.addShapeCountLog(shapeStatus.REDO);
            let obj = UPLOAD_FILES_DATA.selectedImageObj.undoList[UPLOAD_FILES_DATA.selectedImageObj.undoList.length - 1];
            this.addRemoveOBJOnCanvas(obj).then(() => {
                UPLOAD_FILES_DATA.selectedImageObj.shapeList.push(obj); //make it latest
                UPLOAD_FILES_DATA.selectedImageObj.undoList.pop();
                if (UPLOAD_FILES_DATA.selectedImageObj.undoList.length === 0) {
                    disableMarkupRedo();
                }
                enableMarkupUndo();
                enableClearMarkup();
                this.reflectMarkupOnFooter();
            });
        }

        googleEvent.logEvent(EVENT_NAME.REDO_TAPPED);
    };

    clearMarkupOnFile = () => {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        this.markupVar.clearMarkup = false;

        const clonedImageObj = {
            ...UPLOAD_FILES_DATA.selectedImageObj,
            shapeList: [],
            undoList: [],
            updatedSrc: UPLOAD_FILES_DATA.selectedImageObj?.src,
        };

        disableMarkupUndo();
        disableMarkupRedo();
        uploadMarkupRootScope.isResetted = true;
        annCanvas.clear();
        annCanvas.discardActiveObject();
        let clearMarkupIndex = this.getSelectedFileIndex();
        this.handleShapeCount(0, true);
        if (clearMarkupIndex > -1) {
            // Clone and update Redux state immutably
            this.updateThumbnail(clonedImageObj.updatedSrc, (thumbnailData) => {
                clonedImageObj.thumbnail = thumbnailData;
                const updatedImageArray = cloneDeep(reduxStore.getState().uploadFile.imagesArray);
                updatedImageArray[clearMarkupIndex] = {
                    ...clonedImageObj,
                    thumbnail: thumbnailData,
                };
                reduxStore.dispatch(updateImagesArray(updatedImageArray));
            });
        }
        UPLOAD_FILES_DATA.selectedImageObj = clonedImageObj;
        LogFirebase("Upload files", "markup", { name: clonedImageObj.name, event: "markup cleared" });
        drawOnCanvas(false, clonedImageObj);

        googleEvent.logEvent(EVENT_NAME.CLEARALL_TAPPED);
    };

    getSelectedFileIndex = function () {
        if (UPLOAD_FILES_DATA.selectedImageObj == null) {
            return -1;
        }

        return reduxStore.getState().uploadFile.imagesArray.findIndex((obj) => obj.id == UPLOAD_FILES_DATA.selectedImageObj.id);
    };

    handleShapeCount = (increment, reset) => {
        this.currentShapeCount = this.currentShapeCount + increment;
        if (reset) this.currentShapeCount = 0;
    };

    addShapeCountLog = (shapeStatus) => {
        let shapeTypeText = "";
        if (this.markupVar.shape && shapeTextObj[this.markupVar.shape]) {
            shapeTypeText = shapeTextObj[this.markupVar.shape];
        }
        LogFirebase("Upload files", "markup", {
            name: UPLOAD_FILES_DATA.selectedImageObj.name,
            send_msg_shape_type: shapeTypeText + "::" + shapeStatus,
        });
        LogFirebase("Upload files", "markup", { name: UPLOAD_FILES_DATA.selectedImageObj.name, current_objects_count: this.currentShapeCount });
    };

    generateShapeFromObject = (obj) => {
        if (obj.type === NAMED_SHAPE_TYPE.FREEDRAW) {
            return this.generateFreeDrawFromObject(obj);
        }

        if (obj.type === NAMED_SHAPE_TYPE.RECT) {
            return this.generateRectFromObject(obj);
        }

        if (obj.type === NAMED_SHAPE_TYPE.TEXT) {
            return this.generateTextFromObject(obj);
        }

        if (obj.type === NAMED_SHAPE_TYPE.ARROW) {
            return this.generateArrowFromObject(obj);
        }
    };

    generateFreeDrawFromObject = (obj) => {
        const { path, ...rest } = obj;
        return new fabric.Path(path, {
            ...rest,
            localShape: true,
        });
    };

    generateRectFromObject = (obj) => {
        return new fabric.Rect({ ...obj, localShape: true });
    };

    generateTextFromObject = (obj) => {
        const { defaultText, ...rest } = obj;
        return new fabric.IText(defaultText, {
            ...rest,
            localShape: true,
        });
    };

    generateArrowFromObject = (obj) => {
        const { points, ...rest } = obj;
        return new fabric.Polygon(points, {
            ...rest,
            localShape: true,
        });
    };
}
export default new UploadFileMarkupService();
